import type { NsDict } from '../ru';

export const app: NsDict<'app'> = {
  brand: 'Market Table',
  signingIn: 'Anmeldung läuft…',
  activeGame: 'Ihr Spiel läuft',
  seated: 'Sie sitzen an einem Tisch',
  backToTable: 'Zurück zum Tisch',
  'nav.label': 'Bereiche',
  'nav.admin': 'Administration',
  'nav.lobby': 'Lobby',
  'nav.profile': 'Profil',
  demo: 'DEMO',
  demoMore: '· Spiel-Credits · kein echtes Geld',
  demoTitle: 'Spiel-Credits haben keinen Geldwert',
  rules: 'Regeln',
  theme: 'Design wechseln',
  balanceTitle: 'Guthaben an Spiel-Credits',
  'menu.profile': 'Profil und Verlauf',
  'menu.logout': 'Abmelden',
  'conn.connecting': 'Verbindung zum Server wird hergestellt…',
  'conn.lost': 'Keine Verbindung zum Server — neuer Verbindungsversuch…',
  'conn.poll': 'HTTP-Ersatzkanal',
  'conn.code': '(Code {code})',
  'conn.attempts': ', Versuche: {n}.',
  'conn.wsHint': 'Wenn WebSocket in Ihrem Netz nicht verfügbar ist, wechselt der Client automatisch auf den Ersatzkanal.',
  'conn.pollHint': 'Der Server ist auch über HTTP nicht erreichbar — prüfen Sie Ihre Netzwerkverbindung.',
  noConnection: 'keine Verbindung zum Server — neuer Verbindungsversuch läuft',
  'api.offline': 'keine Verbindung zum Server',
  'api.serverError': 'Serverfehler ({status})',
};
